import React, {useEffect, useState} from 'react';
import {IClassNameProps} from "@bem-react/core";
import {useTranslation} from 'react-i18next';
import {KitchenService} from '../../../../3d/services/KitchenService/KitchenService';
import {cnWizardSpec} from '../WizardSpec';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from '../../../../redux/AppStore';
import {TKitchenImages} from '../../../../../common-code/types/TKitchenImages';
import {WizardSpecSnapshot} from '../Snapshot/WizardSpec-Snapshot';
import {Button} from '../../../components/Button';
import {TKitchenCuttingImages} from '../../../../3d/types/TKitchenCuttingImages';
import {WizardSpecImage} from '../Image/WizardSpec-Image';
import {showMessage} from "../../../../helpers";
import {MESSAGE_TYPE_WARNING} from "../../../../constants";
import {LoadingApiData} from "../../../helpers/LoadingApiData/LoadingApiData";
import {TImageScreenSettings} from "../../../../../common-code/types/project/TImageScreenSettings";
import {TKitchenImageSet} from "../../../../../common-code/types/project/TKitchenImageSet";
import {SCREEN_SETTINGS_MAX_COUNT} from "../../../../../common-code/constants";

export interface IWizardSpecImagesProps extends IClassNameProps {
    service: KitchenService;
}

export const WizardSpecImages: React.FC<IWizardSpecImagesProps> =
    ({
         service,
     }) => {
        const loadedTextures: number = useSelector((state: AppState) => state.wizard.loadedTextures);
        const screenSettings: TImageScreenSettings[] | undefined = useSelector((state: AppState) => state.wizard.project?.screenSettings);
        const [images, setImages] = useState<TKitchenImages | undefined>(undefined);
        const [cuttingImages, setCuttingImages] = useState<TKitchenCuttingImages | undefined>(undefined);
        const {t} = useTranslation();
        const dispatch = useDispatch();
        const [loading, setLoading] = useState<boolean>(false);

        useEffect(() => {
            if (loadedTextures > 0) {
                setLoading(true);
                service.createProjectImages().then((images) => {
                    setImages(images);
                    setLoading(false);
                })
            }
        }, [service, loadedTextures]);

        useEffect(() => {
            if (loadedTextures > 0) {
                service.createCuttingImages().then((cuttingImages) => {
                    setCuttingImages(cuttingImages);
                })
            }
        }, [service, loadedTextures]);

        const onAddScreenSettings = () => {
            if (!service.addScreenSettings()) {
                showMessage({
                    type: MESSAGE_TYPE_WARNING,
                    message: t('Добавлено максимальное количество изображений проекта'),
                    autoClose: true,
                    interval: 1500,
                }, dispatch);
            }
        }

        return (
            <div className={cnWizardSpec('Images')}>

                <div className={cnWizardSpec('Snapshots')}>
                    {!images || <>
                        <WizardSpecSnapshot imagesSet={{visual: images.visual, sketch: images.sketch}}
                                            screenSettings={screenSettings ? screenSettings[0] : undefined}
                                            index={-1}
                                            service={service}
                        />
                        {images && images.extraImages && images.extraImages.length ? images.extraImages.map((extraImage: TKitchenImageSet, index: number) => {
                            const screenSettingsItem: TImageScreenSettings | undefined = screenSettings ? screenSettings[index + 1] : undefined;

                            return <WizardSpecSnapshot imagesSet={extraImage}
                                                       screenSettings={screenSettingsItem}
                                                       index={index}
                                                       service={service}
                            />;
                        }) : null}
                        {images && (!screenSettings || screenSettings.length < SCREEN_SETTINGS_MAX_COUNT) ?
                            <div className={cnWizardSpec('AddSnapshot')}>
                                <Button
                                    className={cnWizardSpec('Button')}
                                    leftIcon={{path: 'plus', width: 20, height: 20, marginRight: 8}}
                                    text={t('Добавить ракурс') || undefined}
                                    callBack={onAddScreenSettings}
                                    mods={{
                                        mods: {
                                            color: 'black',
                                            bkg: 'white',
                                            border: 'gray',
                                            fill: 'lightBlack'
                                        },
                                    }}
                                    type={'button'}
                                />
                            </div> : null
                        }
                    </>}
                </div>
                <div className={cnWizardSpec('Cutting')}>
                    {!cuttingImages || <>
                        <div className={cnWizardSpec('TabletopCutting')}>
                            <WizardSpecImage image={cuttingImages.tabletop.image} type={'tabletop'}/>
                            <div className={cnWizardSpec('CuttingInfo')}>
                                {cuttingImages.tabletop.cuttingData.map(data => {
                                    return (
                                        <div className={cnWizardSpec('CuttingItem')} key={data.index}>
                                            <span className={cnWizardSpec('CuttingIndex')}>№{data.index}:</span>
                                            <span className={cnWizardSpec('CuttingLength')}>
                                            {t('длина')} - {data.sizes.length} {t('мм')}{(
                                                data.sizes.realLength !== undefined && data.sizes.realLength > data.sizes.length ?
                                                    ' (' + data.sizes.realLength + ' ' + t('мм') + ')' : '')};
                                        </span>
                                            <span className={cnWizardSpec('CuttingHeight')}>
                                            {t('ширина')} - {data.sizes.width} {t('мм')};
                                        </span>
                                        </div>
                                    );
                                })}

                            </div>
                        </div>
                        <div className={cnWizardSpec('ApronCutting')}>
                            <WizardSpecImage image={cuttingImages.apron.image} type={'apron'}/>
                            <div className={cnWizardSpec('CuttingInfo')}>
                                {cuttingImages.apron.cuttingData.map(data => {
                                    return (
                                        <div className={cnWizardSpec('CuttingItem')} key={data.index}>
                                            <span className={cnWizardSpec('CuttingIndex')}>№{data.index}:</span>
                                            <span
                                                className={cnWizardSpec('CuttingLength')}>{t('длина')} - {data.sizes.length} {t('мм')};</span>
                                            <span
                                                className={cnWizardSpec('CuttingHeight')}>{t('ширина')} - {data.sizes.width} {t('мм')};</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </>}

                </div>
                <LoadingApiData loading={loading} className={cnWizardSpec('Loading')}/>
            </div>
        );
    };